import { init } from "@sentry/remix";
// import { replayIntegration } from "@sentry/remix"; // Session Replay - disabled for cost
/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";

// Add FontAwesome configuration
import { config } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css";

// Prevent FontAwesome from adding its CSS since we did it manually above
config.autoAddCss = false;

// Initialize Sentry only in production
// Note: In Vite client bundles, process.env.NODE_ENV is undefined - use import.meta.env.PROD instead
if (typeof window !== "undefined") {
  const isProduction = import.meta.env.PROD;
  // Debug: verify env values (check browser console after deploy)

  init({
    dsn: "https://5616d8f416446f7d603e5183d6f3ee1f@o4507241641213952.ingest.us.sentry.io/4509490951094272",
    debug: false,
    enabled: isProduction,
    environment: import.meta.env.MODE || "production",
  });
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>,
  );
});
